import { useCallback } from "react";

import { useFlag } from "./useFlags";

declare global {
  interface Navigator {
    userAgentData?: {
      mobile: boolean;
    };
  }
}

const STORAGE_KEY = "isMobile";

const legacyIsMobile = window.innerWidth <= 768;

const detectMobile = () => {
  try {
    const uaMobile = navigator.userAgentData?.mobile;

    if (typeof uaMobile === "boolean") {
      return uaMobile;
    }

    const userAgentMobile = /Android|iPhone|iPad|iPod|Mobile/i.test(
      navigator.userAgent,
    );

    const touchDevice =
      navigator.maxTouchPoints > 0 || "ontouchstart" in window;

    const coarsePointer = window.matchMedia("(pointer: coarse)").matches;

    return userAgentMobile || (touchDevice && coarsePointer);
  } catch (error) {
    console.error("Error detecting mobile device:", error);

    return false;
  }
};

const getUserSettingMobile = () => {
  const savedValue = localStorage.getItem(STORAGE_KEY);

  if (savedValue !== null) {
    return savedValue === "true";
  }

  return;
};

export const useIsMobile = () => {
  const detectedIsMobile = detectMobile();
  const usetSettingIsMobile = getUserSettingMobile();

  const legacyMobileDetection = useFlag("legacyMobileDetection");

  const isMobile = legacyMobileDetection
    ? legacyIsMobile
    : (usetSettingIsMobile ?? detectedIsMobile);

  const toggleMobile = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, String(!isMobile));
  }, [isMobile]);

  return {
    isMobile,
    toggleMobile,
  };
};
